<template>
  <footer>
    <div class="container">
      <div class="grid gap-20 cols-1-1-1">
        <div class="grid gap-15">
          <router-link to="/">
            <img src="@/assets/logo.png" class="logo" alt="Logo" />
          </router-link>
          <p class="a-company">
            The company was created and is located in Armenia. It is protected
            and operates strictly by the laws of Armenia.
          </p>
        </div>
        <div class="grid gap-15">
          <h3>Helpful Links</h3>
          <div class="grid gap-5">
            <router-link to="/about">About Us</router-link>
            <router-link to="/features">Features</router-link>
            <router-link to="/projects">Projects</router-link>
            <router-link to="/faq">F.A.Q.</router-link>
          </div>
        </div>
        <div class="grid gap-15">
          <h3>Contacts</h3>
          <div class="grid gap-5">
            <a
              href="https://www.google.com/maps/place/6+Shinararneri+St,+Yerevan+0038/@40.1931425,44.4733601,18.67z/data=!4m10!1m2!2m1!1sshinararneri+street+6%2F1!3m6!1s0x406abd51f357a0f7:0xde9840ad8c40d104!8m2!3d40.1934909!4d44.4741364!15sChdzaGluYXJhcm5lcmkgc3RyZWV0IDYvMZIBEGdlb2NvZGVkX2FkZHJlc3PgAQA!16s%2Fg%2F11l31wmnx3?entry=ttu&g_ep=EgoyMDI1MDQwOS4wIKXMDSoASAFQAw%3D%3D"
              >Armenia, Yerevan</a
            >
            <a
              href="https://www.google.com/maps/place/6+Shinararneri+St,+Yerevan+0038/@40.1931425,44.4733601,18.67z/data=!4m10!1m2!2m1!1sshinararneri+street+6%2F1!3m6!1s0x406abd51f357a0f7:0xde9840ad8c40d104!8m2!3d40.1934909!4d44.4741364!15sChdzaGluYXJhcm5lcmkgc3RyZWV0IDYvMZIBEGdlb2NvZGVkX2FkZHJlc3PgAQA!16s%2Fg%2F11l31wmnx3?entry=ttu&g_ep=EgoyMDI1MDQwOS4wIKXMDSoASAFQAw%3D%3D"
              >Shinararneri Street 6/1</a
            >
            <a href="mailto:info@mbp.am">E-mail: info@mbp.am</a>
            <div style="display: flex; gap: 3px">
              <a href="https://www.facebook.com/mbpcompany">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M14 13.5H16.5L17.5 9.5H14V7.5C14 6.47062 14 5.5 16 5.5H17.5V2.1401C17.1743 2.09685 15.943 2 14.6429 2C11.9284 2 10 3.65686 10 6.69971V9.5H7V13.5H10V22H14V13.5Z"
                  ></path>
                </svg>
              </a>
              <a href="https://www.linkedin.com/company/mbpcompany/">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path
                    d="M6.94048 4.99993C6.94011 5.81424 6.44608 6.54702 5.69134 6.85273C4.9366 7.15845 4.07187 6.97605 3.5049 6.39155C2.93793 5.80704 2.78195 4.93715 3.1105 4.19207C3.43906 3.44699 4.18654 2.9755 5.00048 2.99993C6.08155 3.03238 6.94097 3.91837 6.94048 4.99993ZM7.00048 8.47993H3.00048V20.9999H7.00048V8.47993ZM13.3205 8.47993H9.34048V20.9999H13.2805V14.4299C13.2805 10.7699 18.0505 10.4299 18.0505 14.4299V20.9999H22.0005V13.0699C22.0005 6.89993 14.9405 7.12993 13.2805 10.1599L13.3205 8.47993Z"
                  ></path></svg
              ></a>
            </div>
          </div>
        </div>
      </div>
      <div class="c_block">© 2025 MBP LLC. All Rights Reserved.</div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style scoped>
svg {
  width: 20px;
  height: 20px;
  opacity: 0.7;
  fill: rgb(var(--m-color));
}
a:hover,
svg:hover {
  opacity: 1;
}
a {
  float: left;
  height: 32px;
  line-height: 32px;
  font-weight: 400;
  font-size: 14px;
  opacity: 0.7;
  color: rgb(var(--m-color));
}
.a-company {
  font-weight: 400;
  font-size: 14px;
  opacity: 0.7;
  color: rgb(var(--m-color));
  line-height: 26px;
  letter-spacing: 0.88px;
}
.logo {
  width: 140px;
}
.c_block {
  padding: 20px 0px;
  text-align: center;
  border-top: 1px solid #dae6fd;
  margin-top: 30px;
  padding-top: 30px;
  padding-bottom: 30px;
  font-weight: 400;
  font-size: 14px;
  color: #6f8ba4;
  letter-spacing: 0.88px;

  border-top: 1px solid rgba(var(--m-color), 0.3);
}
.container {
  padding: 60px 0px 0px 0px;
}
footer {
  width: 100%;
  display: flex;
  justify-content: center;
  background: rgba(var(--m-color), 0.2);
  margin-top: 60px;
}

@media (max-width: 1200px) {
  .container {
    padding: 60px 10px 0px 10px;
  }
}

@media (max-width: 800px) {
  .container * {
    margin: auto;
    text-align: center;
  }
}
</style>
